import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible/flexible'
import qs from 'qs'
import axios from 'axios'
import VueAxios from "vue-axios";

Vue.config.productionTip = false;


Vue.use(VueAxios,axios);

Vue.prototype.$ajax = axios;
Vue.prototype.$qs = qs;

axios.defaults.timeout = 5000; // 请求超时
axios.defaults.baseURL = 'http://api.demourl.com/';  // api 即上面 vue.config.js 中配置的地址

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
